module.exports = __webpack_public_path__ + "img/mockup-mobile-medici.2911fc72.png";